import { Record } from "immutable";
import { DeliveraServiceAvailabilityInterface, TranslationInterface } from "./interface";

export interface DeliveraMenuInterface {
    id: string
    title: TranslationInterface
    subtitle: TranslationInterface
    service_availability: DeliveraServiceAvailabilityInterface[]
    category_ids: string[]
}

const defaultDeliveraMenuProps: DeliveraMenuInterface = {
    id: `_${new Date().getTime()}`,
    title: {
        translations: {
            'fr': 'Menu',
            'en': 'Menu'
        }
    },
    subtitle: {
        translations: {
            'fr': 'Menu',
            'en': 'Menu'
        }
    },
    service_availability: [],
    category_ids: []
};

export default class DeliveraMenu extends Record(defaultDeliveraMenuProps) {};

